import { useEffect, useState } from 'react';
import { getAnalyticsOverview } from '../api/analytics.api';
import type { AnalyticsFilters, AnalyticsSnapshot } from '../types/analytics.types';

export function useAnalytics(filters: AnalyticsFilters = {}) {
  const [analytics, setAnalytics] = useState<AnalyticsSnapshot | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getAnalyticsOverview(filters)
      .then(setAnalytics)
      .catch(() => setError('خطا در دریافت اطلاعات تحلیلی'))
      .finally(() => setLoading(false));
  }, [JSON.stringify(filters)]);

  return { analytics, loading, error };
}
